module.exports = __webpack_public_path__ + "static/img/组 9@2x(3).bb893e78.png";